import {
  SendOutlined,
  SyncOutlined,
  BellOutlined,
  FileSearchOutlined,
  WarningOutlined,
  HourglassOutlined,
} from '@ant-design/icons';

export const DASHBOARD_ICON_MAP: Record<string, React.ReactNode> = {
  direction: <SendOutlined />,
  acceptance: <HourglassOutlined />,
  progress: <SyncOutlined />,
  notification: <BellOutlined />,
  review: <FileSearchOutlined />,
  warning: <WarningOutlined />,
};

export interface ColorClasses {
  bg: string;
  icon: string;
  badge: string;
  border: string;
  hover: string;
}

export const DASHBOARD_COLOR_CLASSES: Record<string, ColorClasses> = {
  blue: {
    bg: 'bg-blue-50',
    icon: 'bg-blue-100 text-blue-600',
    badge: 'bg-blue-600',
    border: 'border-blue-200',
    hover: 'hover:border-blue-300',
  },
  cyan: {
    bg: 'bg-cyan-50',
    icon: 'bg-cyan-100 text-cyan-600',
    badge: 'bg-cyan-600',
    border: 'border-cyan-200',
    hover: 'hover:border-cyan-300',
  },
  green: {
    bg: 'bg-green-50',
    icon: 'bg-green-100 text-green-600',
    badge: 'bg-green-600',
    border: 'border-green-200',
    hover: 'hover:border-green-300',
  },
  orange: {
    bg: 'bg-orange-50',
    icon: 'bg-orange-100 text-orange-600',
    badge: 'bg-orange-500',
    border: 'border-orange-200',
    hover: 'hover:border-orange-300',
  },
  red: {
    bg: 'bg-red-50',
    icon: 'bg-red-100 text-red-600',
    badge: 'bg-red-600',
    border: 'border-red-200',
    hover: 'hover:border-red-300',
  },
  purple: {
    bg: 'bg-purple-50',
    icon: 'bg-purple-100 text-purple-600',
    badge: 'bg-purple-600',
    border: 'border-purple-200',
    hover: 'hover:border-purple-300',
  },
  gray: {
    bg: 'bg-gray-50',
    icon: 'bg-gray-100 text-gray-600',
    badge: 'bg-gray-600',
    border: 'border-gray-200',
    hover: 'hover:border-gray-300',
  },
};
